var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamification1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4714",
    "data-name": "Group 4714",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.567,
    height: 29.559,
    viewBox: "0 0 44.567 29.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2121",
    "data-name": "Rectangle 2121",
    width: 44.567,
    height: 29.559,
    fill: "#7fb1b2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4712",
    "data-name": "Group 4712",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15977",
    "data-name": "Path 15977",
    d: "M27.179,27.546a.769.769,0,0,1-.393-.108,17.433,17.433,0,0,0-17.75,0,.773.773,0,0,1-1.167-.666V3.309a.772.772,0,0,1,.38-.665,18.978,18.978,0,0,1,19.324,0,.773.773,0,0,1,.38.665V26.773a.774.774,0,0,1-.774.773m-9.268-4.082a18.993,18.993,0,0,1,8.5,2.007V3.756a17.434,17.434,0,0,0-16.99,0V25.472a18.993,18.993,0,0,1,8.5-2.007",
    transform: "translate(-4.966 0)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15978",
    "data-name": "Path 15978",
    d: "M28.93,17.882a.77.77,0,0,1-.388-.105,12.786,12.786,0,0,0-12.829,0,.773.773,0,1,1-.777-1.337,14.332,14.332,0,0,1,14.384,0,.773.773,0,0,1-.39,1.442",
    transform: "translate(-9.183 -9.154)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15979",
    "data-name": "Path 15979",
    d: "M28.93,28.839a.77.77,0,0,1-.388-.105,12.786,12.786,0,0,0-12.829,0,.773.773,0,1,1-.777-1.337,14.332,14.332,0,0,1,14.384,0,.773.773,0,0,1-.39,1.442",
    transform: "translate(-9.183 -16.069)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15980",
    "data-name": "Path 15980",
    d: "M28.93,39.8a.77.77,0,0,1-.388-.105,12.786,12.786,0,0,0-12.829,0,.773.773,0,1,1-.777-1.337,14.332,14.332,0,0,1,14.384,0,.773.773,0,0,1-.39,1.442",
    transform: "translate(-9.183 -22.984)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15981",
    "data-name": "Path 15981",
    d: "M28.93,50.754a.77.77,0,0,1-.388-.105,12.786,12.786,0,0,0-12.829,0,.773.773,0,1,1-.777-1.337,14.332,14.332,0,0,1,14.384,0,.773.773,0,0,1-.39,1.442",
    transform: "translate(-9.183 -29.899)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15982",
    "data-name": "Path 15982",
    d: "M22.26,35.412H.773A.773.773,0,0,1,0,34.639V10.048a.773.773,0,0,1,.773-.773h2a.773.773,0,0,1,0,1.547H1.547V33.866h19.94v-.781a.773.773,0,1,1,1.547,0v1.554a.773.773,0,0,1-.773.773",
    transform: "translate(0 -5.853)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15983",
    "data-name": "Path 15983",
    d: "M59.268,27.546a.773.773,0,0,1-.773-.773V3.309a.774.774,0,0,1,.38-.666,18.982,18.982,0,0,1,19.325,0,.775.775,0,0,1,.38.666V26.773a.774.774,0,0,1-1.167.665,17.434,17.434,0,0,0-17.75,0,.77.77,0,0,1-.394.108m.774-23.79V25.471a18.984,18.984,0,0,1,16.991,0V3.756a17.434,17.434,0,0,0-16.991,0",
    transform: "translate(-36.915 0)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15984",
    "data-name": "Path 15984",
    d: "M79.556,17.882a.77.77,0,0,1-.388-.105,12.786,12.786,0,0,0-12.829,0,.773.773,0,1,1-.778-1.337,14.333,14.333,0,0,1,14.385,0,.773.773,0,0,1-.39,1.442",
    transform: "translate(-41.132 -9.154)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15985",
    "data-name": "Path 15985",
    d: "M79.556,28.839a.77.77,0,0,1-.388-.105,12.786,12.786,0,0,0-12.829,0,.773.773,0,1,1-.778-1.337,14.333,14.333,0,0,1,14.385,0,.773.773,0,0,1-.39,1.442",
    transform: "translate(-41.132 -16.069)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15986",
    "data-name": "Path 15986",
    d: "M79.556,39.8a.77.77,0,0,1-.388-.105,12.786,12.786,0,0,0-12.829,0,.773.773,0,1,1-.778-1.337,14.333,14.333,0,0,1,14.385,0,.773.773,0,0,1-.39,1.442",
    transform: "translate(-41.132 -22.984)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15987",
    "data-name": "Path 15987",
    d: "M79.556,50.754a.77.77,0,0,1-.388-.105,12.786,12.786,0,0,0-12.829,0,.773.773,0,1,1-.778-1.337,14.333,14.333,0,0,1,14.385,0,.773.773,0,0,1-.39,1.442",
    transform: "translate(-41.132 -29.899)",
    fill: "#7fb1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15988",
    "data-name": "Path 15988",
    d: "M80.628,35.412H59.141a.773.773,0,0,1-.773-.773V33.085a.773.773,0,0,1,1.547,0v.781h19.94V10.822h-1.23a.773.773,0,1,1,0-1.547h2a.773.773,0,0,1,.773.773V34.639a.773.773,0,0,1-.773.773",
    transform: "translate(-36.835 -5.853)",
    fill: "#7fb1b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamification1);
export default __webpack_public_path__ + "static/media/gamification_1.a908acfe.svg";
export { ForwardRef as ReactComponent };